<template>
  <v-layout row wrap>
    <v-flex xs12 sm6>
      <v-menu
        v-model="menu.m1"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :label="titleDate"
            prepend-icon="event"
            readonly
            v-on="on"
            :value="momentFormatStartDate"
            :error-messages="errorMessages"
          />
        </template>
        <v-date-picker
          header-color="primary"
          color="secondary"
          v-model="date"
          @input="menu.m1 = false"
          locale="es-419"
          :min="min"
        />
      </v-menu>
    </v-flex>
    <v-flex xs12 sm6>
      <div class="border-class-notice">
        <div class="date-picker-notice">
          <v-icon class="clock-notice" color="gradiente">schedule</v-icon>
          <vue-timepicker
            class="pickers"
            v-model="time"
            full-width
            :drop-direction="position"
            format="hh:mm a"
            color="secondary"
            header-color="primary"
            manual-input
          />
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import moment, { min } from 'moment'
import VueTimepicker from 'vue2-timepicker'

// CSS
import 'vue2-timepicker/dist/VueTimepicker.css'
export default {
  components: {
    VueTimepicker,
  },
  props: [
    'titleDate',
    'titleTime',
    'errorMessages',
    'valueDate',
    'valueTime',
    'value',
    'min',
    'hour',
    'location',
  ],
  data: () => ({
    menu: {
      m1: false,
      m2: false,
    },
    date: null,
    time: null,
    dateObject: null,
    today: '',
    position: 'down',
  }),
  methods: {
    showVariables(where) {},
    parseValue() {
      if (this.date) {
        if (this.time) {
          if (this.time.hh != '' && this.time.mm != '' && this.time.a != '') {
            var hora = this.time.hh
            var type = this.time.a
            if (type == 'am') {
              if (hora == 12) hora = '00'
            } else if (type == 'pm') {
              if (hora == 12) hora = '12'
              else hora = Number(hora) + 12
            }
            let time = hora + ':' + this.time.mm + ':00'
            this.dateObject = moment(
              this.date + ' ' + time,
              'YYYY-MM-DD HH:mm'
            ).toDate()
          } else {
            let time = '00:00:00'
            this.dateObject = moment(
              this.date + ' ' + time,
              'YYYY-MM-DD HH:mm'
            ).toDate()
          }
        } else {
          this.dateObject = moment(this.date, 'YYYY-MM-DD').toDate()
        }
      }
      this.$emit('input', this.dateObject)
    },
  },
  watch: {
    value() {
      this.today = new Date().toLocaleDateString('sv-SE')
      this.showVariables('watch value')
      if (this.value === '') {
        this.date = null
        this.time = null
        this.dateObject = null
      } else {
        this.dateObject = this.value
        this.position = this.location
        if (this.dateObject !== null && this.date === null) {
          if (Number.isInteger(this.dateObject)) {
            var d = new Date(this.dateObject)
            this.date = d.toISOString().substr(0, 10)
          } else {
            if (this.dateObject != undefined) {
              this.date = this.dateObject.toISOString().substr(0, 10)
            }
          }
        }
        if (this.dateObject !== null && this.time === null) {
          var hora = moment(new Date(this.dateObject)).format('HH')
          if (hora == 0) {
            hora = '12'
          }
          var minutos = moment(this.dateObject).format('mm')
          var horaFix = '0'
          var type = 'am'
          if (Number(hora) > 12) {
            hora = Number(hora) - 12
            type = 'pm'
            if (Number(hora) < 21) {
              horaFix = horaFix.concat(hora)
            } else {
              horaFix = hora
            }
            this.time = { hh: horaFix, mm: minutos, a: type }
          } else {
            this.time = { hh: hora, mm: minutos, a: type }
          }
        }
      }
    },
    date() {
      this.showVariables('watch date')
      this.parseValue()
    },
    time() {
      this.showVariables('watch time')
      this.parseValue()
    },
  },
  computed: {
    momentFormatStartDate() {
      this.showVariables('computed momentFormatStartDate')

      if (this.dateObject == null) {
        if (this.date != null) {
          return moment(this.date).format('DD/MM/YYYY')
        }
      } else {
        return moment(this.dateObject).format('DD/MM/YYYY')
      }
      return ''
    },
    momentFormatStartTime() {
      this.showVariables('computed momentFormatStartTime')
      if (this.dateObject == null) {
        if (this.date != null) {
          return moment(this.date).format('HH:mm')
        }
      } else {
        var time = { hh: '12', mm: '00', a: 'pm' }
        return time
      }
      return ''
    },
  },
  mounted() {},
  beforeDestroy() {},
}
</script>

<style>
.border-class-notice {
  border: 2px solid #757575;
  height: 57px;
  display: flex;
}

.date-picker-notice {
  font-size: 1.2em;
  display: flex;
  justify-content: center;
  align-items: center;
}

.clock-notice {
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}

.pickers {
  justify-content: center;
  align-items: center;
}
</style>
